/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import BSNavbar from "react-bootstrap/Navbar";
import PropTypes from "prop-types";
import React, {Component} from "react";
import {oneLineTrim} from "common-tags";

export default class NavBrand extends Component {
  static propTypes = {
    assetsUrl: PropTypes.string.isRequired,
    children: PropTypes.any,
  };

  render() {
    const {
      admin,
      assetsUrl,
      brand,
      children,
      tenantId,
    } = this.props;

    return (
      <BSNavbar.Brand>
        <a href="/">
          <img
            alt={brand}
            src={oneLineTrim`
              ${assetsUrl}
              /img
              /tenants
              /${tenantId}
              /logo${admin ? "-admin" : ""}.png
            `}
            style={{display: "inline"}}
          />
          {" "}
          {children}
        </a>
      </BSNavbar.Brand>
    );
  }
}



// WEBPACK FOOTER //
// ../render/components/NavBrand.jsx